<div class="container-fluid service-bg">
    <div class="row">
        <div class="col-md-12 from-top">
            <h1>{{message | translate}}</h1>

            <a href="#/login">
                <button class="mt-4 button">                
                
                    <i class="pr-1 fa fa-sign-in-alt"></i>
                    {{'register_go_to_login' | translate}}
                
            </button>
            </a>
        </div>
    </div>
</div>